export const licensePacksModalStyles = {
  modalBox: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    maxWidth: "calc(100% - 20px)",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
  },
  accessContainer: {
    paddingBottom: "70px",
  },
  formControl: {
    width: "100%",
    px: 2,
    boxSizing: "border-box",
  },
  buttonTextTransform: {
    textTransform: "none",
  },
};
